import {DecimalPipe} from '@angular/common';
import {Component} from '@angular/core';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {zip} from 'rxjs';
import {HomeService} from './home.service';

@Component({
  selector: 'home',
  templateUrl: 'home.component.html',
  providers: [HomeService],
})
export class HomeComponent {
  public debtorId = '';
  public user = {};
  public loading = false;
  public group = 'home';
  public visuals: any = {};
  private stats: {};
  private statsStatus: {};
  constructor(
    public homeService: HomeService,
    public securityService: SecurityService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
    public decimalPipe: DecimalPipe,
  ) {
    this.getVisuals();
    this.getUser();

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.getVisuals();
      },
    });
  }

  ngOnInit() {
    this.getStat();
  }
  filterStatus(status) {
    this.securityService.router.navigate(['/menu/7303'], {
      queryParams: {status: status, buyerId: this.debtorId},
    });
  }
  navigateToResendInv() {
    this.securityService.router.navigate(['/menu/7603'], {
      queryParams: {param: '', buyerId: this.debtorId},
    });
  }
  public getVisuals() {
    this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
  }

  public getUser(): void {
    this.user =
      localStorage.getItem('home_info') == null
        ? {}
        : this.visualsService.getFromStorageAsJSON('home_info', false);
  }
  getStat() {
    this.debtorId = this.debtorId == null ? '' : this.debtorId;
    this.loading = true;
    zip(
      this.homeService.getStatsPerStatus(this.debtorId),
      this.homeService.getStats(this.debtorId),
    ).subscribe({
      next: ([statsStatus, stats]) => {
        this.statsStatus = statsStatus.data;
        this.stats = stats.data;
        this.loading = false;
      },
    });
  }
  public valueChanged(modalname: string, value: any) {
    this.debtorId = value.dbtrId;
  }
}
